import { render, staticRenderFns } from "./TextoPoliticaPrivacidad.vue?vue&type=template&id=0e5f4974"
import script from "./TextoPoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./TextoPoliticaPrivacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports